import React, { type FC, type PropsWithChildren } from 'react';

import styles from './ViewerMenu.css';

export const ViewerMenuWrapper: FC<PropsWithChildren<unknown>> = ({ children }) => {
    return <div className={styles.wrapper}>{children}</div>;
};

export const ViewerMenuStart: FC<PropsWithChildren<unknown>> = ({ children }) => {
    return <div className={styles.start}>{children}</div>;
};

export const ViewerMenuCenter: FC<PropsWithChildren<unknown>> = ({ children }) => {
    return <div className={styles.center}>{children}</div>;
};

export const ViewerMenuEnd: FC<PropsWithChildren<unknown>> = ({ children }) => {
    return <div className={styles.end}>{children}</div>;
};
